import {
  ThunkAction,
  Action,
  configureStore,
  combineReducers,
} from '@reduxjs/toolkit'
import thunkMiddleware from 'redux-thunk'

import appSlice from 'domains/application/slice'
import authSlice from 'domains/auth/slice'
import orgSlice from 'domains/organization/slice'
import vehicleSlice from 'domains/vehicle/slice'

export const reducer = {
  application: appSlice.reducer,
  vehicle: vehicleSlice.reducer,
  auth: authSlice.reducer,
  organization: orgSlice.reducer,
  // [truckexApi.reducerPath]: truckexApi.reducer,
}

const middleware = [
  thunkMiddleware,
  // truckexApi.middleware,
]

const configStore = (
  defaultState?: Record<string, unknown>,
  { logActions, devTools }: { logActions?: boolean; devTools?: boolean } = {},
) => {
  reducer
  return configureStore({
    reducer: combineReducers(reducer),
    middleware: (getDefaultMiddleware) => {
      // must not use .prepend()
      // see: https://github.com/reduxjs/redux-thunk/issues/333
      let returnMiddleware = getDefaultMiddleware().concat(...middleware)
      if (logActions === true) {
        // returnMiddleware = returnMiddleware.concat(logger)
      }
      return returnMiddleware
    },
    devTools,
    preloadedState: defaultState ?? {},
  })
}

export type AppStore = ReturnType<typeof configStore>
export type State = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
export type AppGetState = AppStore['getState']
export type DispatchFunc = () => AppDispatch

export type AppThunk<ReturnType = unknown> = ThunkAction<
  ReturnType,
  State,
  unknown,
  Action<string>
>

export function createStore(
  defaultState: Partial<State>,
  opts: { logActions?: boolean; devTools?: boolean } = {},
) {
  const store = configStore(defaultState, opts)
  // setupListeners(store.dispatch)
  return store
}
